import { MAX_OUTLINE_POINTS, MIN_OUTLINE_POINTS, type SurfacePoint } from '@repo/api-contracts';
import type { RefObject } from 'react';
import { type PhotoDimensions, photoToPercent, validateOutline } from '@/entities/edit-area';
import { usePolygonPointer } from './use-polygon-pointer';

interface Options {
  svgRef: RefObject<SVGSVGElement | null>;
  photoSize: PhotoDimensions;
  /** 추출 모드. 꺼지면 열린 경로를 버린다. */
  active: boolean;
  onClose: (points: SurfacePoint[]) => void;
  /** Esc 로 추출을 그만둘 때. */
  onCancel: () => void;
}

const validateOutlineDraft = (points: readonly SurfacePoint[]): string | null =>
  points.length < MIN_OUTLINE_POINTS
    ? `점을 ${MIN_OUTLINE_POINTS}개 이상 찍어 주세요.`
    : validateOutline(points);

/**
 * '상품 추출하기' — 운영자가 제품 경계에 점을 찍어 경로를 닫는다. 시스템은 점을 미리 놓지 않는다.
 * 점은 사진 % 좌표이고, 점 찍기·닫기·키 조작은 공용 다각형 훅(usePolygonPointer)이 한다.
 */
export const useOutlinePointer = ({ svgRef, photoSize, active, onClose, onCancel }: Options) =>
  usePolygonPointer<SurfacePoint>({
    svgRef,
    photoSize,
    active,
    toPoint: (photoPx) => photoToPercent(photoSize, photoPx),
    distancePx: (a, b) =>
      Math.hypot(((a.x - b.x) / 100) * photoSize.widthPx, ((a.y - b.y) / 100) * photoSize.heightPx),
    validate: validateOutlineDraft,
    maxPoints: MAX_OUTLINE_POINTS,
    maxPointsMessage: `윤곽 점은 최대 ${MAX_OUTLINE_POINTS}개입니다. 첫 점을 눌러 닫아 주세요.`,
    onClose: (points) => {
      onClose(points);
      return null;
    },
    onCancel,
  });
